import type { FaireProductEntity } from "../../entity_types/product";

export const p_2vst3vyeut: FaireProductEntity = {
  token: "p_2vst3vyeut",
  type: "product",
  name: "sweet pea watercolor wall art print",
  brandToken: "b_mmdanrh9jf",
  brandName: "emily lex studio",
  imageUrl:
    "https://cdn.faire.com/fastly/c77e0da51aef2bcaec9a77c6c27f54bd5bd4cec9645668e1528adf175b8a3c9b.jpeg",
  galleryImageUrls: [],
  priceDollars: 11,
  description:
    "This lovely sweet pea in a pot art print is perfect for displaying around the home.\n\n• Print of original watercolor artwork by Emily Lex\n• Printed in full color on thick, superfine paper\n• Packaged in a clear protective sleeve with chipboard backing\n• Frame and mat not included",
  tags: [],
  msrpDollars: 22,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:14:54.430Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
